document.addEventListener("DOMContentLoaded", function () {

    /* =========================================================
       BIG DEAL EVENT PRODUCTS
       ========================================================= */

    // 15% OFF products
    const discount15Handles = [
        "aquaplanet-max-10-6-inflatable-paddle-board-package-glacier-v2",
        "aquaplanet-max-plus-118-inflatable-sup-package-beach",
        "aquaplanet-self-inflating-roof-rack",
        "aquaplanet-waterproof-tote-bag-20l-black",
        "aquaplanet-stainless-steel-water-bottle-life-is-simple"
    ];

    // 10% OFF products
    const discount10Handles = [
        "aquaplanet-pace-10-6-inflatable-paddle-board-package-coral",
        "aquaplanet-pace-118-inflatable-paddle-board-package-nori",
        "aquaplanet-dropstitch-kayak-seat-and-footrest-for-sup",
        "aquaplanet-buoyancy-aid-pro"
    ];

    const promoText = "for Big Deal Event";


    /* =========================================================
       HELPERS
       ========================================================= */

    function applyPercentageDiscount(priceText, discountPercentage) {

        const price = parseFloat(
            priceText.replace(/[^0-9.]/g, "")
        );

        if (isNaN(price)) {
            return null;
        }

        const discountedPrice =
            price - (price * discountPercentage / 100);

        return `£${discountedPrice.toFixed(2)}`;
    }


    function isSaleClothing(text) {

        if (!text) {
            return false;
        }

        const productText = text.toLowerCase();

        return (
            productText.includes("hoodie") ||
            productText.includes("t-shirt") ||
            productText.includes("tshirt")
        );
    }


    function getDiscountPercentage(handle, productText = "") {

        if (discount15Handles.includes(handle)) {
            return 15;
        }

        if (discount10Handles.includes(handle)) {
            return 10;
        }

        // All Hoodies and T-Shirts = 15% OFF
        if (isSaleClothing(productText)) {
            return 15;
        }

        return null;
    }


    function getProductHandle(href) {

        if (!href) {
            return null;
        }

        const match = href.match(/\/products\/([^?\/]+)/);

        return match ? match[1] : null;
    }


    /* =========================================================
       COLLECTION PAGES + HOMEPAGE
       ========================================================= */

    const urlParts = window.location.pathname
        .split("/")
        .filter(Boolean);

    const isCollectionPage =
        urlParts.includes("collections");

    const isProductPage =
        urlParts.includes("products");


    if (
        isCollectionPage ||
        window.location.pathname === "/"
    ) {

        const productCards =
            document.querySelectorAll(
                ".cl-product-card-inner-container"
            );

        productCards.forEach(function (card) {

            const productLink =
                card.querySelector(
                    "a[href*='/products/']"
                );

            if (!productLink) {
                return;
            }

            const productHandle =
                getProductHandle(
                    productLink.getAttribute("href")
                );

            if (!productHandle) {
                return;
            }

            const discountPercentage =
                getDiscountPercentage(
                    productHandle,
                    card.textContent
                );

            if (!discountPercentage) {
                return;
            }

            const priceElement =
                card.querySelector(
                    ".price-variation"
                );

            if (!priceElement) {
                return;
            }

            const currentPriceText =
                priceElement.textContent;

            const discountedPrice =
                applyPercentageDiscount(
                    currentPriceText,
                    discountPercentage
                );

            if (discountedPrice) {
                priceElement.textContent =
                    `${discountedPrice} ${promoText}`;
            }

        });
    }


    /* =========================================================
       PRODUCT PAGES
       ========================================================= */

    if (isProductPage) {

        const productHandle =
            urlParts[
                urlParts.indexOf("products") + 1
            ];

        const productTitle =
            document.querySelector("h1")
                ?.textContent || "";

        const discountPercentage =
            getDiscountPercentage(
                productHandle,
                productTitle
            );

        if (discountPercentage) {

            // Main product price
            const priceSnippet =
                document.querySelector(
                    ".product-details-price-snippet .sale-price"
                );

            if (priceSnippet) {

                const discountedPrice =
                    applyPercentageDiscount(
                        priceSnippet.textContent,
                        discountPercentage
                    );

                if (discountedPrice) {
                    priceSnippet.textContent =
                        `${discountedPrice} ${promoText}`;
                }
            }


            // Add-to-cart area price
            const formPrice =
                document.querySelector(
                    ".product-form-price .price"
                );

            if (formPrice) {

                const discountedPrice =
                    applyPercentageDiscount(
                        formPrice.textContent,
                        discountPercentage
                    );

                if (discountedPrice) {
                    formPrice.textContent =
                        `${discountedPrice} ${promoText}`;
                }
            }
        }
    }


    /* =========================================================
       REBUY CART - SHOW BIG DEAL SAVING
       ========================================================= */

    function updateRebuySavings() {

        const productLinks =
            document.querySelectorAll(
                'a[href*="/products/"]'
            );

        productLinks.forEach(function (link) {

            const handle =
                getProductHandle(
                    link.getAttribute("href")
                );

            if (!handle) {
                return;
            }


            /*
             * Find the individual Rebuy cart item.
             */
            const cartItem =
                link.closest(
                    ".rebuy-cart__flyout-item, " +
                    ".rebuy-cart__flyout-content-item, " +
                    ".rebuy-cart__flyout-item-product"
                );

            if (!cartItem) {
                return;
            }


            const discountPercentage =
                getDiscountPercentage(
                    handle,
                    cartItem.textContent
                );

            if (!discountPercentage) {
                return;
            }


            /*
             * Don't add the saving twice.
             */
            if (
                cartItem.querySelector(
                    ".big-deal-saving"
                )
            ) {
                return;
            }


            /*
             * Find displayed prices inside this Rebuy item.
             *
             * We specifically want the NEW discounted price,
             * e.g. £330.65 rather than the crossed-out £499.
             */
            const priceElements =
                Array.from(
                    cartItem.querySelectorAll(
                        "[class*='price'], [class*='money']"
                    )
                );


            let discountedPrice = null;
            let discountedPriceElement = null;


            for (const element of priceElements) {

                const style =
                    window.getComputedStyle(element);

                if (
                    style.display === "none" ||
                    style.visibility === "hidden"
                ) {
                    continue;
                }

                const text =
                    element.textContent.trim();

                const match =
                    text.match(
                        /£\s*([0-9,]+(?:\.[0-9]{1,2})?)/
                    );

                if (!match) {
                    continue;
                }

                /*
                 * Avoid crossed-out / compare-at prices.
                 */
                const isComparePrice =
                    element.tagName === "S" ||
                    element.tagName === "DEL" ||
                    style.textDecorationLine.includes(
                        "line-through"
                    ) ||
                    element.closest("s, del");

                if (isComparePrice) {
                    continue;
                }

                const value =
                    parseFloat(
                        match[1].replace(",", "")
                    );

                if (
                    !isNaN(value) &&
                    value > 0
                ) {
                    discountedPrice = value;
                    discountedPriceElement = element;
                    break;
                }
            }


            if (
                !discountedPrice ||
                !discountedPriceElement
            ) {
                return;
            }


            /*
             * Price shown by Rebuy is already discounted.
             *
             * Example:
             * £330.65 is 85% of £389.
             *
             * Therefore:
             * saving = discounted price ×
             *          discount / remaining percentage
             */
            const saving =
                discountedPrice *
                (
                    discountPercentage /
                    (100 - discountPercentage)
                );


            const savingElement =
                document.createElement("div");

            savingElement.className =
                "big-deal-saving";

            savingElement.textContent =
                `Save £${saving.toFixed(2)}`;


            /*
             * Put saving immediately before the price.
             */
            discountedPriceElement
                .parentNode
                .insertBefore(
                    savingElement,
                    discountedPriceElement
                );

        });
    }


    /* =========================================================
       REBUY CART WATCHER
       ========================================================= */

    updateRebuySavings();

    let rebuyUpdateTimer;

    const rebuyObserver =
        new MutationObserver(function () {

            clearTimeout(rebuyUpdateTimer);

            rebuyUpdateTimer =
                setTimeout(
                    updateRebuySavings,
                    100
                );

        });

    rebuyObserver.observe(
        document.body,
        {
            childList: true,
            subtree: true
        }
    );


    /* =========================================================
       STYLE FOR "SAVE £X.XX"
       Added here because this is a JS asset.
       ========================================================= */

    const bigDealStyle =
        document.createElement("style");

    bigDealStyle.textContent = `
        .big-deal-saving {
            font-size: 13px;
            line-height: 1.3;
            color: #25b964;
            margin: 3px 8px 3px 0;
            font-weight: 500;
            white-space: nowrap;
        }
    `;

    document.head.appendChild(
        bigDealStyle
    );

});